"use client";

import { LoaderCircle } from "lucide-react";

export function ChatActivity({ locale = "de" }: { locale?: "de" | "en" }) {
  const isEn = locale === "en";

  return (
    <div
      role="status"
      aria-atomic="true"
      className="flex items-center gap-2 py-1 text-xs text-neutral-500 dark:text-neutral-400"
    >
      <LoaderCircle
        aria-hidden="true"
        size={13}
        className="shrink-0 animate-spin motion-reduce:animate-none text-emerald-500 dark:text-emerald-400"
      />
      <span>{isEn ? "Thinking & writing answer …" : "Antwort wird vorbereitet …"}</span>
    </div>
  );
}
